__turbopack_context__.v({
  "image": "picturesCarousel-module-scss-module__RBrp1W__image",
  "imageContainer": "picturesCarousel-module-scss-module__RBrp1W__imageContainer",
});
